export default [
    {
        path: 'relatorio-atendimento-domiciliar',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-atendimento-domiciliar' */
            '@/views/atencao-basica/relatorio-atendimento-domiciliar/Index'
        ),
        redirect: 'relatorio-atendimento-domiciliar/index',
        children: [
            {
                name: 'atencao-basica-relatorio-atendimento-domiciliar-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-atendimento-domiciliar' */
                    '@/views/atencao-basica/relatorio-atendimento-domiciliar/List.vue'
                ),
            },
        ],
    },
]